import { Box, Typography } from '@mui/material'

interface DataPanelProps {
    title?: string
    customTitleContent?: JSX.Element
    widget?: JSX.Element
    content: JSX.Element
    minHeight?: number | string
    style?: any
}

export const DataPanel = ({
    title,
    customTitleContent,
    widget,
    content,
    minHeight: _minHeight,
    style,
}: DataPanelProps) => {
    const minHeight = _minHeight ? _minHeight : 'fit-content'

    return (
        <Box
            style={{
                minHeight,
                padding: '30px',
                borderRadius: '10px',
                backgroundColor: '#F2F6F9',
                ...style,
            }}
        >
            <Box sx={{ display: 'flex' }}>
                {title ? (
                    <Typography variant="h6" style={{ marginBottom: '20px' }}>
                        {title}
                    </Typography>
                ) : (
                    customTitleContent && (
                        <Box sx={{ marginBottom: '20px' }}>{customTitleContent}</Box>
                    )
                )}
                {widget && (
                    <Box
                        sx={{
                            marginLeft: 'auto',
                            marginRight: 0,
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        {widget}
                    </Box>
                )}
            </Box>
            {content}
        </Box>
    )
}
